import { AsyncPipe } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { IonModal, IonRouterOutlet, IonToast } from '@ionic/angular/standalone'

import { SessionTimeoutService } from '../../shared/services/session-timeout.service'
import { WebsocketService } from '../../shared/services/websocket.service'
import { WhiteLabelService } from '../../shared/services/white-label.service'
import { AuthenticatedLayoutService } from './authenticated-layout.service'

const EXCHANGE_COMPACT_AGE_VERIFIED_KEY = 'exchange_compact_age_verified'

@Component({
	selector: 'app-authenticated-layout',
	templateUrl: './authenticated-layout.component.html',
	styleUrl: './authenticated-layout.component.scss',
	standalone: true,
	imports: [IonRouterOutlet, AsyncPipe, IonToast, IonModal],
})
export class AuthenticatedLayoutComponent implements OnInit {
	isAgeVerificationOpen = sessionStorage.getItem(EXCHANGE_COMPACT_AGE_VERIFIED_KEY) !== 'true'

	isAgeVerificationRejected = false

	canDismissAgeVerification = () => !this.shouldShowAgeVerification()

	constructor(
		private readonly authenticatedLayoutService: AuthenticatedLayoutService,
		private readonly sessionTimeoutService: SessionTimeoutService,
		private readonly whiteLabelService: WhiteLabelService,
		readonly websocketService: WebsocketService,
	) {}

	ngOnInit() {
		this.authenticatedLayoutService.initializeApp()
		this.sessionTimeoutService.setupSessionTimeout()
	}

	confirmAgeVerification() {
		sessionStorage.setItem(EXCHANGE_COMPACT_AGE_VERIFIED_KEY, 'true')
		this.isAgeVerificationRejected = false
		this.isAgeVerificationOpen = false
	}

	rejectAgeVerification() {
		this.isAgeVerificationRejected = true
	}

	shouldShowAgeVerification() {
		return this.whiteLabelService.isV2Skin() && this.isAgeVerificationOpen
	}
}
